import { action } from 'typesafe-actions';
import type { IRecipient } from '../../../common/recipients/types';
import type { IFile } from '../../../dtm/types';
import type { IRecipientsState } from './types';

export enum ActionTypes {
  FETCH = 'dtmRecipients/FETCH',
  FETCH_DONE = 'dtmRecipients/FETCH_DONE',
  UPDATE_RECIPIENTS = 'dtmRecipients/UPDATE_RECIPIENTS',
  UPDATE_OPTIONAL_RECIPIENTS = 'dtmRecipients/UPDATE_OPTIONAL_RECIPIENTS',
  SAVE = 'dtmRecipients/SAVE',
  SAVE_DONE = 'dtmRecipients/SAVE_DONE',
  RESET = 'dtmRecipients/RESET',
  FETCH_CONTACTS = 'dtmRecipients/FETCH_CONTACTS',
  FETCH_CONTACTS_DONE = 'dtmRecipients/FETCH_CONTACTS_DONE',
  CLEAR_CONTACTS = 'dtmRecipients/CLEAR_CONTACTS',
  CREATE_PRIME_CONTACT = 'dtmRecipients/CREATE_PRIME_CONTACT',
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const reset = (newStore?: IRecipientsState) => action(ActionTypes.RESET, newStore);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetch = (envelopeId: string, impersonatedPrimeUserGuid?: string) =>
  action(ActionTypes.FETCH, { envelopeId, impersonatedPrimeUserGuid });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchDone = (file: IFile, optionalRecipients: IRecipient[], recipients: IRecipient[]) =>
  action(ActionTypes.FETCH_DONE, { file, optionalRecipients, recipients });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateRecipients = (recipients: IRecipient[]) => action(ActionTypes.UPDATE_RECIPIENTS, recipients);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateOptionalRecipients = (ors: IRecipient[]) => action(ActionTypes.UPDATE_OPTIONAL_RECIPIENTS, ors);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const save = (envelopeId: string) => action(ActionTypes.SAVE, envelopeId);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const saveDone = () => action(ActionTypes.SAVE_DONE);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchContacts = () => action(ActionTypes.FETCH_CONTACTS);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchContactsDone = (contacts: any) => action(ActionTypes.FETCH_CONTACTS_DONE, contacts);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const clearContacts = () => action(ActionTypes.CLEAR_CONTACTS);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const createPrimeContact = (contact: { firstName: string; lastName: string; email: string }) =>
  action(ActionTypes.CREATE_PRIME_CONTACT, contact);
